import { useState } from 'react';
// import { CARD_ELEMENT_TYPE } from '../../constants';

/**
 * useCardElementConfigurationHistory hook.
 * Used for storing past CardElementConfigurations.
 *
 * @returns {{cardElementConfigurationHistory: *[], onCardElementConfigurationHistoryInsert: onCardElementConfigurationHistoryInsert}}
 */
const useCardElementConfigurationHistory = () => {
  const [cardElementConfigurationHistory, setCardElementConfigurationHistory] =
    useState([]);

  const onCardElementConfigurationHistoryInsert = cardElementConfiguration => {
    setCardElementConfigurationHistory(prev => [
      ...prev,
      cardElementConfiguration,
    ]);
  };

  return {
    cardElementConfigurationHistory,
    onCardElementConfigurationHistoryInsert,
  };
};

export default useCardElementConfigurationHistory;
